<template>
  <el-dropdown-item
    :command="action"
    :disabled="disabled"
  >
    <div class="dropdown-el__item" v-if="action">
      <Picture
        v-if="action.icon"
        :url="action.icon"
        class="dropdown-el__item-icon"
      />
      <Icon
        v-else-if="icon && action.id != '0'"
        class="dropdown-el__item-icon"
        :iconName="icon"
        :iconColor="iconColor || '#0075DB'"
        :disabled="disabled"
      />
      <p class="dropdown-el__item-text">
        {{ action.lbl && action.lbl.value ? action.lbl.value : action.name }}
      </p>
    </div>
  </el-dropdown-item>
</template>

<script>
import { DropdownItem } from 'element-ui';
import Picture from 'Elements/Picture/Picture';
import Icon from 'Elements/Icon/Icon';
export default {
  props: {
    action: {
      type: Object,
      default: () => ({})
    },
		disabled: {
			type: Boolean,
			default: false
		},
		icon: {
			type: String,
			default: ''
		},
		iconColor: {
			type: String,
			default: ''
		}
  },
  components: {
    'el-dropdown-item': DropdownItem,
    Picture,
    Icon
  }
};
</script>
<style lang="scss" scoped>

.dropdown-el__item {
	display: flex;
	flex-direction: row;
	align-items: center;
	min-height: 48px;
	border-radius: 4px;
	cursor: pointer;

	&-icon {
		margin-right: 16px;
		height: 24px;
		width: 24px;
		filter: invert(72%) sepia(11%) saturate(382%) hue-rotate(172deg)
			brightness(90%) contrast(91%);
	}

	&-text {
		margin: 0;
		color: $black-190;
		font-size: 15px;
		font-family: 'Roboto', sans-serif;
		line-height: 24px;
		cursor: pointer;
	}
}
</style>
